import { get, post } from "../../../../../axios-interceptor-setup/apiService"; 

const BASE_URL = "/smart_city_tcu";

export const getLastRefreshDate = () => {
    return post(`${BASE_URL}/lastRefreshDateDeviceHealth
 `, {});
}

export const getCityDepotContract = (body) => {
    return post(`${BASE_URL}/locationFilter `, {...body});
}

export const getDeviceHealthCityWiseTableData = (body) => {
    return post(`${BASE_URL}/deviceHealthCityWise `, {...body});
}

export const getDeviceHealthDeviceHealthDepotWiseData = (body) => {
    return post(`${BASE_URL}/deviceHealthDepotWise `, {...body});
}

export const getMinutesWiseData = (body) => {
    return post(`${BASE_URL}/deviceHealthVehicleWise `, {...body});
}

// Device Transmission table (hour-wise; send `hour` for minute-wise)
export const getVehicleTransmissionData = (body) => {
    return post(`${BASE_URL}/deviceHealthVehicleTransmission`, {...body});
}

// KPI

export const getTotalVehicle = (body) => {
    return post(`${BASE_URL}/totalVehicleDeviceHealth `, {...body});
}

export const getTotalDevice = (body) => {
    return post(`${BASE_URL}/totalAvailableDeviceHealth `, {...body});
}

// Overall Frequency KPI: vehicle count per delay bucket
export const getOverallFrequency = (body) => {
    return post(`${BASE_URL}/overallFrequency`, {...body});
}

export const getFrequencyData = (body) => {
    return post(`${BASE_URL}/frequencyDeviceHealth`, {...body});
}

export const getDelayFrequencyData = (body) => {
    return post(`${BASE_URL}/delayFrequencyDeviceHealth`, {...body});
}

export const getHealthyUnhealthyVehicles = (body) => {
    return post(`${BASE_URL}/totalAvailableDeviceHealthStatus`, {...body});
}



// CSV downloads: posts the filters to a download api and saves the file as `<fileName>.csv`
export const downloadCsv = (api, body, fileName) => {
    return post(`${BASE_URL}/${api}`, {...body}, { responseType: "blob" })
        .then((data) => {
            const url = window.URL.createObjectURL(data);

            const link = document.createElement("a");
            link.href = url;
            link.download = `${fileName}.csv`;

            document.body.appendChild(link);
            link.click();
            link.remove();

            window.URL.revokeObjectURL(url);
        });
}

// Frequency Distribution table
// TODO: confirm endpoint names with backend
export const getFrequencyBucketCityWise = (body) => {
    return post(`${BASE_URL}/frequencyBucketCityWise`, {...body});
}

export const getFrequencyBucketDepotWise = (body) => {
    return post(`${BASE_URL}/frequencyBucketDepotWise`, {...body});
}

export const getFrequencyBucketDepotVehicles = (body) => {
    return post(`${BASE_URL}/frequencyBucketDepotVehicles`, {...body});
}
